<template>
    <div v-if="trips.length" class="transfer-addon" :class="[padding && 'padding']">
        <div class="transfer-addon-inner">
            <div class="transfer-addon-illustration">
                <Illustration :data="{ type: 'Transfer3' }" />
            </div>

            <div class="transfer-addon-content">
                <p class="transfer-addon-content-title">
                    {{ t({ key: 'shared.transfer_product' }) }}
                </p>

                <ul v-if="rows.length > 0" class="transfer-addon-content-rows">
                    <li v-for="(row, index) in rows" :key="index">
                        <Icon type="Check" /> {{ row }}
                    </li>
                </ul>

                <Trips :trips="trips" />
            </div>
        </div>
    </div>
    <Banner v-else />
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, watch, computed, onMounted } from 'vue';
    import { getTransferTrips } from '@/helpers/transfer/transfer';
    import { TransferTrip } from '@/helpers/transfer/transfer.interfaces';
    import { useStore } from '@/store';
    import { trackClarity } from '@/tracking/clarity';
    import { ClarityEvent } from '@/tracking/clarity/types';
    import { CheckoutStepState } from '@/store/checkout/types';
    import Illustration from '@ui/components/Illustration/Illustration.vue';
    import Icon from '@ui/components/Icon/Icon.vue';
    import Trips from './Trips/Trips.vue';
    import Banner from './Banner/Banner.vue';

    export default defineComponent({
        name: 'TransferAddon',
        methods: { t },
        props: { padding: { type: Boolean, default: true } },
        components: { Illustration, Icon, Banner, Trips },
        setup() {
            const store = useStore();

            onMounted(() => {
                trackClarity(ClarityEvent.CHECKOUT_ADDON_TRANSFER);
            });

            const states = computed<CheckoutStepState[]>(
                () => store.getters['checkout/getStates']
            );

            const trips = computed<TransferTrip[]>(
                () => store.getters['checkout/getTransferTrips']
            );

            watch(states, (newStates, prevStates) => {
                if (newStates.length !== prevStates?.length) {
                    updateTransferTrips();
                }
            });

            async function updateTransferTrips() {
                const cart = store.state.cart.data;
                store.dispatch('checkout/setTransferTrips', await getTransferTrips(cart));
            }

            const rows: string[] = [
                t({ key: 'shared.air_conditioning' }),
                t({ key: 'shared.vehicles_less_than_5_years_old' }),
                t({ key: 'shared.all_hours_customer_hapiness' }),
            ];

            return { trips, rows };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Transfer.scss';
</style>
